exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lists-vendors-edit-vendor .modal-content .button-row{margin-top:15px}", ""]);

// exports
